import { IFileToRepairUploadStatus } from "@/services/fileRepairService";
import { IContext, ISetUploadProgress } from "./types";

export const originalFileUploadStatusIs = (
  status: IFileToRepairUploadStatus,
) => (_ctx: IContext, event: ISetUploadProgress) => {
  return event.status.original === status;
};

export const repairedFileUploadStatusIs = (
  status: IFileToRepairUploadStatus,
) => (_ctx: IContext, event: ISetUploadProgress) => {
  return event.status.original === status;
};
